import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    datosLaborales: [],
  },

  getters: {
    getDatosLaborales: (state) => state.datosLaborales,
  },

  mutations: {
    SET_DATOS_LABORALES(state, datosLaborales) {
      state.datosLaborales = datosLaborales;
    },
  },

  actions: {
    async fetchDatosLaborales({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/datosLaborales`)
        .then((response) => {
          commit('SET_DATOS_LABORALES', response.data.data);
        });
    },

    async saveDatosLaborales(_, datosLaborales) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${datosLaborales.fk_idExpediente}/datosLaborales`, datosLaborales);
    },

    async updateDatosLaborales(context, datosLaborales) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/expedientes/${datosLaborales.fk_idExpediente}/datosLaborales/${datosLaborales.idDatosLaborales}`,
          datosLaborales,
        );

      context.dispatch('fetchDatosLaborales', datosLaborales.fk_idExpediente);
    },
  },
};
